import script from "./AlignmentSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlignmentSelector.vue?vue&type=script&setup=true&lang=ts"

import "./AlignmentSelector.vue?vue&type=style&index=0&id=ec7eb60a&lang=scss"

const __exports__ = script;

export default __exports__